module.exports = __webpack_public_path__ + "img/Dekontaminationsgruppe_Gerät.2c03da73.svg";